import { render, staticRenderFns } from "./FactoryCase.vue?vue&type=template&id=ecef8038&scoped=true&"
import script from "./FactoryCase.vue?vue&type=script&lang=js&"
export * from "./FactoryCase.vue?vue&type=script&lang=js&"
import style0 from "./FactoryCase.vue?vue&type=style&index=0&id=ecef8038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecef8038",
  null
  
)

export default component.exports